import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {HttpParams} from '@angular/common/http';
import {TextTypeDto} from '../../dtos/text/text-type/text-type-dto';
import {TextTypeService} from "../../services/text/text-type.service";
import {SearchTriggerObject} from "../../shared/SearchTrigger";
import {TableComponent} from "../common/table/table.component";
import {UntypedFormControl} from "@angular/forms";
import {FormOptionsLists} from "../../shared/FormOptionsLists";
import {BreakpointObserver, Breakpoints, BreakpointState} from "@angular/cdk/layout";
import {MatDialog} from "@angular/material/dialog";
import {NotificationService} from "../../services/common/notification.service";
import {NewTextTypeComponent} from "./new-text-type/new-text-type.component";
import {ActivatedRoute, Router} from "@angular/router";
import {filter} from "rxjs";
import {SharedService} from "../../services/common/shared.service";

@Component({
  selector: 'app-text-type',
  templateUrl: './text-type.component.html',
  styleUrl: './text-type.component.scss',
  standalone: false,
})
export class TextTypeComponent implements OnInit, OnDestroy {

  @ViewChild(TableComponent) tableC: TableComponent;


  textTypes: TextTypeDto[] = [];
  displayedColumns = ['name', 'modes', 'domains', 'interactions', 'details'];

  isAuthorized: boolean;
  isAdmin: boolean;
  displayEditingTools = false;

  // checkboxes to add entries to a Sammelmappe, off until the user asks for them
  selectMode = false;

  toggleSelectMode(): void {
    this.selectMode = !this.selectMode;
  }

  searchTrigger: SearchTriggerObject = {trigger: false, params: new HttpParams()}
  categoryControl: number = null;


  // filter options
  formOptionsLists = new FormOptionsLists();
  // filter by name
  searchControl = new UntypedFormControl('');
  // filter by modes
  modesFilterModeList = this.formOptionsLists.modes;
  modesFilterModeControl = new UntypedFormControl('');
  // filter by domains
  domainsFilterModeList = this.formOptionsLists.domains;
  domainsFilterModeControl = new UntypedFormControl('');
  // filter by interactions
  interactionsFilterModeList = this.formOptionsLists.interactions;
  interactionsFilterModeControl = new UntypedFormControl('');
  // filter by media
  mediaFilterModeList = this.formOptionsLists.media;
  mediaFilterModeControl = new UntypedFormControl('');
  // filter by purpose
  purposeFilterModeList = this.formOptionsLists.purpose;
  purposeFilterModeControl = new UntypedFormControl('');
  // filter by representations
  representationsFilterModeList = this.formOptionsLists.representations;
  representationsFilterModeControl = new UntypedFormControl('');

  resultsLength = 20;

  entryId: number = null;

  constructor(protected textTypeService: TextTypeService, public authService: AuthService, public matDialog: MatDialog,
              private notificationService: NotificationService, private observer: BreakpointObserver,
              private route: ActivatedRoute, private router: Router, private sharedService: SharedService) {
  }

  ngOnInit() {
    [this.isAuthorized, this.isAdmin] = this.authService.isAuthorizedAndAdmin()
    this.observer.observe([
      '(max-width:529px)',
      '(min-width:530px) and (max-width:899px)',
      '(min-width:900px) and (max-width:1089px)',
      '(min-width:1090px)',
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).subscribe((breakpointState: BreakpointState) => {
      if (breakpointState.breakpoints['(max-width:529px)']) {
        if (this.displayEditingTools === true && this.isAdmin) {
          this.displayedColumns = this.formOptionsLists.displayedColumnsTextTypeEditing.filter(s => s !== 'domains' && s !== 'interactions');
        } else {
          this.displayedColumns = this.formOptionsLists.displayedColumnsTextTypeDetails.filter(s => s !== 'domains' && s !== 'interactions');
        }
      }
      if (breakpointState.breakpoints['(min-width:530px) and (max-width:899px)']) {
        if (this.displayEditingTools === true && this.isAdmin) {
          this.displayedColumns = this.formOptionsLists.displayedColumnsTextTypeEditing.filter(s => s !== 'domains');
        } else {
          this.displayedColumns = this.formOptionsLists.displayedColumnsTextTypeDetails.filter(s => s !== 'domains');
        }
      }
      if (breakpointState.breakpoints['(min-width:1090px)']) {
        if (this.displayEditingTools === true && this.isAdmin) {
          this.displayedColumns = this.formOptionsLists.displayedColumnsTextTypeEditing;
        } else {
          this.displayedColumns = this.formOptionsLists.displayedColumnsTextTypeDetails;
        }
      }
    });
    this.route.queryParams
      .pipe(filter(params => !!params['id'] || !!params['q']))
      .subscribe((params:HttpParams) => {
      this.entryId = params['id'];
      if (params['q']) {
        this.searchControl.setValue(params['q']);
      }
      this.getParams();
      this.sharedService.clearIdParam(this.router);
    });
  }

  ngOnDestroy(): void {
    this.observer.ngOnDestroy();
  }


  toggleEditingTools(change: boolean) {
    if (change) {
      this.displayEditingTools = !this.displayEditingTools;
    }
    if (this.displayEditingTools && this.isAdmin) {
      if (!this.displayedColumns.includes('edit')) {
        const lastIndex = this.displayedColumns.length - 1;
        this.displayedColumns.splice(lastIndex, 0, 'edit');
      }
    } else {
      this.displayedColumns = this.displayedColumns.filter(c => c !== 'edit');
    }
  }

  getParams() {
    let params = new HttpParams();
    if (this.entryId){
      params = params.append('id', String(this.entryId));
    }
    if (this.searchControl.value !== '') {
      params = params.append('name', String(this.searchControl.value));
    }
    if (this.modesFilterModeControl.value !== '') {
      params = params.append('modes', String(this.modesFilterModeControl.value));
    }
    if (this.domainsFilterModeControl.value !== '') {
      params = params.append('domains', String(this.domainsFilterModeControl.value));
    }
    if (this.interactionsFilterModeControl.value !== '') {
      params = params.append('interactions', String(this.interactionsFilterModeControl.value));
    }
    if (this.mediaFilterModeControl.value !== '') {
      params = params.append('media', String(this.mediaFilterModeControl.value));
    }
    if (this.purposeFilterModeControl.value !== '') {
      params = params.append('purpose', String(this.purposeFilterModeControl.value));
    }
    if (this.representationsFilterModeControl.value !== '') {
      params = params.append('representations', String(this.representationsFilterModeControl.value));
    }
    this.searchTrigger.params = params;
    // reset entryId so next search is not affected by previous search
    this.entryId = null;
  }

  /**
   * opens a popup to create a new word
   */
  openNewTextTypeDialog() {
    const dialogRef = this.matDialog.open(NewTextTypeComponent);
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          this.searchTrigger.params = new HttpParams();
          this.searchTrigger.trigger = !this.searchTrigger.trigger;
        }
      },
      error: (error) => {
        this.notificationService.openSnackBar(error);
      }
    });
  }


  sendExportTextTypesRequest() {
    this.textTypeService.exportAll().subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([x.body], {type: 'text/csv'});
      const data = window.URL.createObjectURL(newBlob);

      const link = document.createElement('a');
      link.href = data;
      link.download = x.headers.get('content-disposition').split('filename=')[1];
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
  }
}
